<div class="auth-page">
  <div class="auth-card" [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">
    <h1 class="auth-heading">Welcome to Uniformax.</h1>
    <p class="auth-subtitle">Sign in to securely access your account.</p>

    <form name="loginForm" [formGroup]="loginForm" novalidate (ngSubmit)="onSubmit()">
      <div class="flex flex-col gap-4">
        <input pInputText id="email" name="email" formControlName="email" placeholder="Username or Email"
          (keyup.enter)="onSubmit()" class="w-full" />
        <p-password [toggleMask]="true" required id="password" name="password" placeholder="Password" [feedback]="false"
          formControlName="password" (keyup.enter)="onSubmit()" styleClass="w-full"></p-password>
        <button type="submit" pButton aria-label="Continue" class="w-full mt-2" [disabled]="loginForm.invalid">
          Continue
        </button>
      </div>

      <div *ngIf="!!error" class="text-red-500 text-center mt-3">{{error}}</div>
    </form>

    <div class="text-center mt-4">
      <a routerLink="/auth/forgot-password" class="text-primary font-medium hover:underline">Forgot password?</a>
    </div>
  </div>
</div>
